<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="title-no">201</span><br/><span class="org">O</span><span class="ltgrn">r</span><span class="yellow">g</span><span class="grn">a</span><span class="org">n</span><span class="drkgrn">i</span><span class="yellow">c</span> <span class="grn">B</span><span class="yellow">a</span><span class="org">b</span><span class="ltgrn">y</span><br/><span class="title1">AND</span><br/><span class="ltgrn">T</span><span class="org">o</span><span class="yellow">d</span><span class="drkgrn">d</span><span class="org">l</span><span class="yellow">e</span><span class="ltgrn">r</span> <span class="org">M</span><span class="ltgrn">e</span><span class="yellow">a</span><span class="org">l</span><span class="drkgrn">s</span></h1>
<h2 class="subtitle">The Healthiest Toddler and Baby Food Recipes You Can Make!</h2>
<h2 class="author">TAMIKA L. GARDNER, <span class="light">author of <i>201 Organic Baby Purées</i></span></h2>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="publisher">AVON, MASSACHUSETTS</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?a35bfc22